import useIsMobileSize from 'src/hooks/useIsMobileSize';
import { DesktopLayout, WithoutHeader } from 'src/layout';
import { Wrapper, Container } from 'src/widgets/FeedFilter/SidebarShell';
import AIMonitoringBlock from 'src/widgets/FeedFilter/AIMonitoringBlock';
import { Paper, Typography, Box } from '@mui/material';

import CollapsibleHintBlock from 'src/components/CollapsibleHintBlock';

import ChatsAndChannels, { IChatsAndChannelsScreenProps } from './Content';

export default function ChatsAndChannelsScreen(props: IChatsAndChannelsScreenProps) {
    const isMobile = useIsMobileSize();

    if (isMobile) {
        return (
            <WithoutHeader showBack>
                <ChatsAndChannels {...props} />
            </WithoutHeader>
        );
    }

    return (
        <DesktopLayout
            rightSidebar={
                <Wrapper
                    elevation={0}
                    square={true}
                >
                    <Container
                        elevation={0}
                        isDisabled={false}
                    >
                        <AIMonitoringBlock />
                        <CollapsibleHintBlock
                            title="Как добавить чаты"
                            bullets={[
                                'Используйте только те чаты, где действительно есть ваша целевая аудитория.',
                                'Добавляйте только активные чаты с регулярными обсуждениями.',
                                'Чтобы добавить в мониторинг закрытый чат или группу, добавьте ссылку на приглашение.',
                                'Спам-чаты или группы автоматически удаляются из мониторинга.',
                                'Добавляйте каналы только если хотите отслеживать посты — лидов там не будет.',
                                'Не добавляйте кавычки.',
                            ]}
                            example={[
                                'Например:',
                                'Для юридических услуг добавьте чаты, где пользователи могут попросить совета или просьбу порекомендовать знакомого юриста.',
                            ]}
                        />
                    </Container>
                </Wrapper>
            }
        >
            <ChatsAndChannels {...props} />
        </DesktopLayout>
    );
}
